import { render } from "./FIBO.vue?vue&type=template&id=d979c65e&scoped=true"
import script from "./FIBO.vue?vue&type=script&lang=js"
export * from "./FIBO.vue?vue&type=script&lang=js"

import "./FIBO.vue?vue&type=style&index=0&id=d979c65e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d979c65e"]])

export default __exports__